<div class="modal-header" *ngIf="false">
  {{ horseName }}
  <div class="row ms-auto justify-content-end">
    <!--
    <div class="col-auto pt-1" *ngIf="studyFiles.length > 0" style="font-size: 12px;padding-top: 6px !important;padding-right: 0px;text-align: right;">
      <label> Go to -</label>
    </div>

    <div class="col-auto">
      <div class="dropdown" style="width:250px;" data-bs-auto-close="outside" *ngIf="studyFiles.length > 0">
        <button class="btn btn-outline-primary dropdown-toggle" style="width:250px;" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          Media Types
        </button>
        <ul class="dropdown-menu" style="width: 250px; border-color: #1b6da6; border-radius: 0;padding-bottom:0;">
          <li *ngFor="let studyFile of studyFiles; let isLast = last"
              [ngStyle]="!isLast ? {'border-bottom': '1px solid #ccc'} : {}">
            <a class="dropdown-item" href="javascript:void(0)" (click)="openViewer($event,studyFile)">
              <span>{{studyFile.documentTypeName}}</span> <i class="fas fa-external-link-alt float-end ms-2 shadow-bottom" ></i>
            </a>
            <div class="dropdown-item" *ngIf="studyFile.renderTextBox" [@slideDown]>
              <div class="row">
                <div class="col-12"><span>Declare client name</span> <i class="fa fa-times cursor-pointer text-danger float-end ms-2" (click)="openViewer($event,studyFile)"></i></div>
                <input class="form-control col me-2" [(ngModel)]="studyFile.disclosedClientName" placeholder="Declare client name to view" type="text" />
                <button type="button" (click)="openViewer($event,studyFile)" class="btn col-auto btn-outline-primary"><i class="fa fa-eye"></i></button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
-->

    <div class="col-auto">
      <button type="button"
              class="btn-close m-0"
              aria-label="Close"
              (click)="closePopup()"></button>
    </div>
  </div>
</div>
<div class="modal-body">
  <iframe [src]="sanitizedUrl"
          width="100%"
          scrolling="yes"
          frameborder="0"
          style="border: 0; height: 100vh"
          allowfullscreen></iframe>
</div>
